module.exports = __webpack_public_path__ + "src/img/index_menu/4.png?cadbdd8e21f1129917a926c3301108ad";


//////////////////
// WEBPACK FOOTER
// ./src/img/index_menu/4.png
// module id = 177
// module chunks = 0